<template>
  <div>
    <v-row>
      <v-col cols="12">
        <TipoCalculo v-model="model"/>
      </v-col>
      <v-col cols="12">
        <input-select label="Tipo de Operação" v-model="model.TipoOperacaoCred" @change="changeOperacao"
          :options="operacao" required />
      </v-col>
      <v-col cols="12">
        <input-select label="Produto" v-model="model.Produto" @change="changeProduto" :options="produtos" return-object
          required />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-label>Modalidade</v-label>
        <input-radiogroup name="Indexador" row v-model="model.TipoIndexador" @change="changeIndexador" required>
          <v-radio label="Pré-Fixado" :value="1" />
          <v-radio label="Pós-Fixado" :value="2" />
        </input-radiogroup>
      </v-col>
      <v-col cols="6">
        <input-select label="Indexador Pós Fixado" v-model="model.TipoIndiceFinan"
          :options="$api.Estruturadas.Indexador" :disabled="model.TipoIndexador !== 2"
          :required="model.TipoIndexador === 2" />
      </v-col>
      <v-col cols="6">
        <input-number label="Percentual Indexador" v-model="model.PercIndiceFinan" format="percent"
          :disabled="model.TipoIndexador !== 2" :required="model.TipoIndexador === 2" />
      </v-col>
      <v-col cols="6">
        <input-number label="Taxa de juros a.m." v-model="model.TxJuros" precision="5" max="999.99999" format="percent"
          required />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: null
  },
  data () {
    return {
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    produtos () {
      const lista = this.$api.Estruturadas.GetProdutos(
        this.model.DocumentoFederal,
        this.model.TipoOperacaoCred,
        this.$param.EST_PRODUTOS
      );
      return lista;
    },
    operacao () {
      return this.$api.Estruturadas.GetTipoOperacaoByTipoPessoa(this.model.DocumentoFederal, this.$param.EST_PRODUTOS);
    }
  },
  methods: {
    changeIndexador () {
      const th = this;
      if (th.model.TipoIndexador === 1) {
        th.$set(th.model, 'TipoIndiceFinan', null)
        th.$set(th.model, 'PercIndiceFinan', '')
      }
    },
    changeOperacao (value) {
      this.$set(this.model, 'TipoOperacaoNome', null);
      if (value) { this.$set(this.model, 'TipoOperacaoNome', this.$api.Estruturadas.TipoOperacaoCred.find(p => p.value === value).text); }
      this.$set(this.model, 'DtDesembolso', null);
      this.$set(this.model, 'DtEmissao', null);
      this.$set(this.model, 'DtPrimeiroVencto', null);
      this.$set(this.model, 'TipoIndiceFinan', null);
      this.$set(this.model, 'Prazo', null);
      this.$set(this.model, 'Produto', null);
      this.$set(this.model, 'ModeloCalculo', null);
      this.$set(this.model, 'TipoIndexador', null);
      this.$set(this.model, 'TxJuros', null);
      this.$set(this.model, 'VlrAvaliacao', null);
      this.$set(this.model, 'VlrCadastro', null);
      this.$set(this.model, 'VlrCredito', null);
    },
    changeProduto (item) {
      const th = this
      th.$set(th.model, 'TipoContrato', null)
      if (item && item.value) {
        th.$set(th.model, 'TipoContratoSigla', item.value)
        th.$set(th.model, 'TipoContratoTela', item.value)
        th.$set(th.model, 'TipoContratoDescricao', item.value + ' - ' + item.text)
      }
      if (item.value !== 'CPV') {
        th.$set(th.model, 'GarantiaSimulacao', [])
      }
    },
  }
}
</script>
